import "~/postcss/index.css";
import '@webcomponents/custom-elements';
import 'rails-plus/es6/bundles/modernizr';
import 'mutation-observer';
import 'what-input';
import 'whatwg-fetch';
import 'dom4';
import "@hotwired/turbo-rails"

// import BlueimpGallery from 'rails-plus/es6/modules/BlueimpGallery';
import Flips          from 'rails-plus/es6/modules/Flips';
import Remodals       from 'rails-plus/es6/modules/Remodals';

import ApexCharts      from 'apexcharts';
import Rails           from '@rails/ujs';
import posthog         from 'posthog-js'

import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers";
const controllers = import.meta.glob("~/controllers/*_controller.js", { eager: true });

import AceEditor                 from '~/modules/AceEditor';
import AsyncPartials             from '~/modules/AsyncPartials';
import AutosizedTextareas        from '~/modules/AutosizedTextareas';
import BrowserLocalePanel        from '~/modules/BrowserLocalePanel';
import BrowserUpdate             from '~/modules/BrowserUpdate';
// import Bvi                       from '~/modules/Bvi';
import Choices2Mimic             from '~/modules/Choices2Mimic';
import Choices2Select            from '~/modules/Choices2Select';
import Choices2UserId            from '~/modules/Choices2UserId';
import Clipboard                 from '~/modules/Clipboard';
import DisabledGroups            from '~/modules/DisabledGroups';
import DynamicSticky             from '~/modules/DynamicSticky';
import Fileinputs                from '~/modules/Fileinputs';
import FlashItems                from '~/modules/FlashItems';
import FormWithStickyPanel       from '~/modules/FormWithStickyPanel';
import LaddaButtons              from '~/modules/LaddaButtons';
import LottieOnHover             from '~/modules/LottieOnHover';
// import MainSlider                from '~/modules/MainSlider';
import MasunGrid                 from '~/modules/MasunGrid';
// import MedicalCarousel           from '~/modules/MedicalCarousel';
import MicroModals               from '~/modules/MicroModals';
import PageEvent                 from '~/modules/PageEvent';
import PagyAutoScroll            from '~/modules/PagyAutoScroll';
import ShareonButtons            from '~/modules/ShareonButtons';
import SmoothScrollLinks         from '~/modules/SmoothScrollLinks';
import SortablesCourseCategories from '~/modules/SortablesCourseCategories';
import SortablesCourseCmodules   from '~/modules/SortablesCourseCmodules';
import TickFlip                  from '~/modules/TickFlip';
import Tooltips                  from '~/modules/Tooltips';
import Tours                     from '~/modules/Tours';
import ujs                       from '~/modules/ujs';

window.ApexCharts = ApexCharts;
window.PageEvent = PageEvent;
window.Rails = Rails;
window.ujs = ujs;

AceEditor.start();
AsyncPartials.start();
AutosizedTextareas.start();
// BlueimpGallery.start();
BrowserLocalePanel.start();
BrowserUpdate.start();
// Bvi.start();
Choices2Mimic.start();
Choices2Select.start();
Choices2UserId.start();
Clipboard.start();
DisabledGroups.start();
DynamicSticky.start();
Fileinputs.start();
FlashItems.start();
Flips.start();
FormWithStickyPanel.start();
LaddaButtons.start();
LottieOnHover.start();
// MainSlider.start();
MasunGrid.start();
// MedicalCarousel.start();
MicroModals.start();
PagyAutoScroll.start();
Rails.start();
Remodals.start();
ShareonButtons.start();
SortablesCourseCategories.start();
SortablesCourseCmodules.start();
TickFlip.start();
Tooltips.start();
Tours.start();

if (!('scrollBehavior' in document.documentElement.style) || window.safari !== undefined) { SmoothScrollLinks.start(); }

PageEvent.delegate('turbo:load', 'page:load');

const application = Application.start();
registerControllers(application, controllers);

if (import.meta.env.MODE === 'production') {
  posthog.init('phc_rD8KVtq4an78CpbKKmZONmpGKcfzVGJ2HMymscxigN1',
    {
      api_host: 'https://eu.i.posthog.com',
      person_profiles: 'identified_only' // or 'always' to create profiles for anonymous users as well
    }
  )
}

if (document.readyState !== 'loading') {
  const event = document.createEvent('Event');
  event.initEvent('DOMContentLoaded', true, true);
  window.document.dispatchEvent(event);
}
